import { render } from "./settings_index.vue?vue&type=template&id=ff787ce0&scoped=true"
import script from "./settings_index.vue?vue&type=script&lang=js"
export * from "./settings_index.vue?vue&type=script&lang=js"

import "./settings_index.vue?vue&type=style&index=0&id=ff787ce0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff787ce0"]])

export default __exports__